import React from 'react';
import {
  Button, Grid,
  Typography,
} from '@mui/material';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { Tabs } from '@gamiphy/loyalty-station-desktop/store/ui';
import InviteSteps from './InviteSteps';
import Tab from '../Tab';

const Referral: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Tab
      tab={Tabs.DemoReferral}
      header={(
        <Typography fontSize={16} fontWeight={700}>
          <Trans i18nKey="shared.referral" defaults="Referral" />
        </Typography>
      )}
    >
      <Grid
        container
        direction="column"
        width="100%"
        gap={2}
      >
        <Grid
          item
          sx={{
            fontSize: 13,
            fontWeight: 400,
          }}
        >
          {t('referral.tab.title', 'Invite your friends and everybody wins')}
        </Grid>
        <Grid
          item
          sx={{
            fontSize: 13,
            fontWeight: 400,
          }}
        >
          {t('referral.tab.stepsTitle', 'How it works:')}
        </Grid>
        <InviteSteps />
        <Grid item container direction="column" alignItems="stretch">
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: '100%',
              display: 'block',
            }}
          >
            {t('missions.referral.cta', 'Invite')}
          </Button>
        </Grid>
      </Grid>
    </Tab>
  );
};

export default Referral;
